<template>
  <div class="nav">
    <div class="nav-container">
      <div class="nav-title">首页</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Navbar'
}
</script>

<style scoped>
.nav {
  background-color: var(--primary-dark);
  padding: 12px 0;
  position: sticky;
  top: 0;
  z-index: 100;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
}

.nav-container {
  max-width: min(1200px, 96%);
  margin: 0 auto;
}

.nav-title {
  color: var(--white);
  font-size: clamp(1rem, 2.5vw, 1.2rem);
  font-weight: 500;
}
</style>